import React from 'react';
import Styles from "./Groups.module.scss";
import {Modal} from "react-bootstrap";


const FiltersModal = ({ onClear, onApply, onClose, tintColor, filterOptions, activeFiltersFromStore, hasActiveFilters }) => {

    const { employees, services, objects } = filterOptions;
    const [activeFilters, setActiveFilters] = React.useState(activeFiltersFromStore);
    const [showActionButtons, setShowActionButtons] = React.useState(false);

    React.useEffect(() => {
        if (
            activeFilters.employees.length ||
            activeFilters.services.length ||
            activeFilters.objects.length ||
            hasActiveFilters
        ) {
            setShowActionButtons(true);
        } else {
            setShowActionButtons(false);
        }
    }, [activeFilters, hasActiveFilters]);

    const toggleCheckbox = (id, type) => {
        const copy = {...activeFilters};

        if (copy[type].includes(id)) {
            const index = copy[type].findIndex(idx => idx === id);

            copy[type].splice(index, 1);
        } else {
            copy[type].push(id);
        }

        setActiveFilters(copy);
    }

    const clearFilters = () => {
        onClear();
    };

    const applyFilters = () => {
        onApply(activeFilters);
    };

    const renderItem = (item, index, type, isSelected) => {
        return (
            <li key={`${item.id}-${index}-${type}`} className={Styles.itemWrapper}>
                <p className={Styles.itemName}>
                    {item.name}
                </p>
                <label className={Styles.checkboxLabel}>
                    <input
                        type="checkbox"
                        checked={isSelected}
                        className={Styles.checkboxInput}
                        onChange={() => toggleCheckbox(item.id, type)}
                    />
                    <span
                        className={Styles.checkboxToggle}
                        style={ isSelected ? { borderColor: tintColor, backgroundColor: tintColor } : {}}
                    ></span>
                </label>
            </li>
        )
    }

    return (
        <Modal
            show={true}
            className={Styles.modalContainer}
            container={document.getElementById('root_appybee_widget')}
            onHide={onClose}
            style={{ display: 'flex' }}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Filters
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={Styles.filtersWrapper}>
                <ul className={Styles.filters}>
                    {
                        employees.map((employee, index) => renderItem(
                            employee,
                            index,
                            'employees',
                            activeFilters['employees'].includes(employee.id)
                        ))
                    }
                </ul>
                <ul className={Styles.filters}>
                    {
                        services.map((service, index) => renderItem(
                            service,
                            index,
                            'services',
                            activeFilters['services'].includes(service.id)
                        ))
                    }
                </ul>
                <ul className={Styles.filters}>
                    {
                        objects.map((object, index) => renderItem(
                            object,
                            index,
                            'objects',
                            activeFilters['objects'].includes(object.id)
                        ))
                    }
                </ul>
            </Modal.Body>
            { showActionButtons && (
                <div className={Styles.actionButtonsWrapper}>
                    <button
                        className={`${Styles.actionButton} ${Styles.clear}`}
                        style={{ borderColor: tintColor, color: tintColor }}
                        onClick={clearFilters}
                    >
                        clear
                    </button>
                    <button
                        className={`${Styles.actionButton} ${Styles.apply}`}
                        style={{ backgroundColor: tintColor }}
                        onClick={applyFilters}
                    >
                        apply
                    </button>
                </div>
            )}
        </Modal>
    )
}

export default FiltersModal;
